export function TracePrecedentsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      role="img"
      aria-label="Trace Precedents"
    >
      <path
        d="M2.3125 2.89286V5.67857H4.9375V2.89286H2.3125ZM1 2.89286C1 2.12388 1.58789 1.5 2.3125 1.5H4.9375C5.66211 1.5 6.25 2.12388 6.25 2.89286V3.58929H9.75V2.89286C9.75 2.12388 10.3379 1.5 11.0625 1.5H13.6875C14.4121 1.5 15 2.12388 15 2.89286V5.67857C15 6.44754 14.4121 7.07143 13.6875 7.07143H11.0625C10.3379 7.07143 9.75 6.44754 9.75 5.67857V4.98214H6.25V5.67857C6.25 5.98036 6.15977 6.26183 6.00391 6.49107L7.72656 8.92857H10.1875C10.9121 8.92857 11.5 9.55245 11.5 10.3214V13.1071C11.5 13.8761 10.9121 14.5 10.1875 14.5H7.5625C6.83789 14.5 6.25 13.8761 6.25 13.1071V10.3214C6.25 10.0196 6.34023 9.73817 6.49609 9.50893L4.77344 7.07143H2.3125C1.58789 7.07143 1 6.44754 1 5.67857V2.89286ZM7.5625 10.3214V13.1071H10.1875V10.3214H7.5625ZM13.6875 2.89286H11.0625V5.67857H13.6875V2.89286Z"
        fill="currentColor"
      />
    </svg>
  );
}
